(function () {
  if (window.__vesaKauf) return;
  window.__vesaKauf = true;

  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; } catch (e) { return {}; }
  }
  function proxy() { return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db'; }
  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }
  function norm(s) { return String(s || '').replace(/mm/gi, '').replace(/[×X]/g, 'x').replace(/\s+/g, ''); }

  function lauf() {
    var felder = document.querySelectorAll('[data-vkh-lochbild]');
    if (!felder.length) return;
    felder.forEach(function (f) { f.querySelectorAll('.vkh__lb--dein').forEach(function (x) { x.classList.remove('vkh__lb--dein'); }); });
    var refs = (auswahl().refs || []).map(String);
    if (!refs.length) return;
    Promise.all(refs.map(function (r) {
      return abruf(proxy() + '/monitors/' + encodeURIComponent(r)).then(function (j) {
        var v = (j && j.ok && j.data && j.data.vesa) || {};
        return (v.patterns || []).map(norm);
      }).catch(function () { return []; });
    })).then(function (listen) {
      var muster = [].concat.apply([], listen);
      felder.forEach(function (f) {
        f.querySelectorAll('[data-vkh-muster]').forEach(function (x) {
          if (muster.indexOf(norm(x.getAttribute('data-vkh-muster'))) > -1) x.classList.add('vkh__lb--dein');
        });
      });
    });
  }

  function spitze() {
    var f = document.querySelector('.vkh__flaeche');
    var an = document.querySelector('.vkr__st--an') || document.querySelector('.vkr__r--an');
    if (!f || !an) return;
    var b = f.getBoundingClientRect();
    if (!b.width) return;
    function lage(el) { var r = el.getBoundingClientRect(); return Math.max(16, Math.min(b.width - 16, r.left + r.width / 2 - b.left)) + 'px'; }
    f.style.setProperty('--vkh-spitze', lage(an));
    var auch = !document.querySelector('.vkr__st--an') && document.querySelector('.vkr__r--auch');
    f.classList.toggle('vkh__flaeche--zwei', !!auch);
    if (auch) f.style.setProperty('--vkh-spitze-2', lage(auch));
  }
  function start() { lauf(); spitze(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('resize', spitze);
  window.addEventListener('load', spitze);
  document.addEventListener('finder:auswahl', lauf);
  window.addEventListener('storage', function (e) { if (e.key === '3idee_auswahl') lauf(); });
})();
